import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store/store'
import MasterplanService from './services/MasterplanService'
import BuildingService from './services/BuildingService'
import ApartmentService from './services/ApartmentService'
import PackageService from './services/PackageService'
import PoiService from './services/PoiService'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  console.log('ifNotAuthenticated', store.getters['UserStore/userLoggedIn'])
  if (!store.getters['UserStore/userLoggedIn']) {
    next()
    return
  }
  next('/')
}

// const ifAuthenticated = (to, from, next) => {
//   if (store.getters['UserStore/userLoggedIn']) {
//     next()
//     return
//   }
//   next('/login')
// }

const ifAuthenticated = async (to, from, next) => {
  try {
    await store.dispatch('AuthStore/refreshUserProfile')
    if (to.path === '/login') {
      next('/')
    } else {
      next()
    }
  } catch (e) {
    console.warn(e)
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Think Home',
      component: Home
    },
    {
      path: '/organizations',
      name: 'Organizations',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./components/RecordLists/OrganizationList.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/organizations/:organizationId',
      name: 'Organization Details',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/OrganizationsDetails.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/system-health',
      name: 'System Health',
      component: () => import('./views/SystemHealth.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/projects',
      name: 'Projects',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Projects.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/projects/:projectId',
      name: 'Explore Project',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/ProjectExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/projects/:projectId/new-media',
      name: 'Media Manager Add',
      component: () => import('./views/MediaManagerAdd.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/projects/:projectId/edit-media/:mediaId',
      name: 'Media Manager Edit',
      component: () => import('./views/MediaManagerEdit.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/projects/:projectId/edit-media/:mediaId/media-links',
      name: 'Media Manager Edit Links',
      component: () => import('./views/MediaManagerEditLinks.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/apps',
      name: 'Apps',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Apps.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/app/:appId',
      name: 'Menus',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Menus.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/pois',
      name: 'POIs',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Pois.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/menu-item/:menuItemId',
      name: 'Menu Item',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/MenuItem.vue'),
      beforeEnter: ifAuthenticated
    },
    // {
    //   path: '/projects/:projectId/masterplans',
    //   name: 'masterplans',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import('./views/Masterplans.vue'),
    //   beforeEnter: ifAuthenticated
    // },
    {
      path: '/masterplans/:masterplanId',
      name: 'Explore Masterplan',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/MasterplanExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/packages/:packagesId',
      name: 'Explore Packages',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/PackagesExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/masterplans/:masterplanId/parcels/:parcelId',
      name: 'Explore Parcel',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/ParcelExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/masterplans/:masterplanId/buildings/:buildingId',
      name: 'Explore Building',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/BuildingExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path:
        '/masterplans/:masterplanId/buildings/:buildingId/apartments/:apartmentId',
      name: 'Explore Apartment',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/ApartmentExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path:
        '/masterplans/:masterplanId/buildings/:buildingId/apartmentTypes/:apartmentTypeId',
      name: 'Explore Apartment Type',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/ApartmentTypeExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path:
        '/masterplans/:masterplanId/buildings/:buildingId/apartmentOrientations/:apartmentOrientationId',
      name: 'Explore Apartment Orientation',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import('./views/ProjectFlow/ApartmentOrientationExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/pois/:poiId',
      name: 'Explore Poi',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectFlow/PoiExplore.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/project-media',
      name: 'Media Project Select',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/ProjectsMedia.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/media/:projectId',
      name: 'Project Media',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Media.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/media',
      name: 'Media',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Media.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/gallery',
      name: 'Gallery',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/Media.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/polygons-editor',
      name: 'Polygons Editor',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/PolygonsEditor.vue'),
      beforeEnter: ifAuthenticated
    },
    // {
    //   path: '/media/:projectId/gallery/:galleryId',
    //   name: 'Gallery',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import('./views/Gallery.vue'),
    //   beforeEnter: ifAuthenticated
    // },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('./views/About.vue')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('./views/LoginForm.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import('./views/Logout.vue'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/signup',
      name: 'Sign Up',
      component: () => import('./views/SignUp.vue'),
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/email-verified',
      name: 'emailVerified',
      component: () => import('./views/EmailVerified.vue'),
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/reset-login',
      name: 'Reset Login',
      component: () => import('./views/ResetLogin.vue')
    },
    {
      path: '/user-profile',
      name: 'User Profile',
      component: () => import('./views/UserProfile.vue'),
      beforeEnter: ifAuthenticated
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (store.getters.guardBeforeLeaveEnabled) {
    store.dispatch('DialogStore/open', {
      title: 'You did not save the data!',
      text: 'All changes will be lost!',
      okText: 'Stay',
      ok: () => {
        next(false)
      },
      cancelText: 'Discard and leave',
      cancel: () => {
        next()
      }
    })
  } else {
    next()
  }
})

// On a cold page load (F5) all Vuex state is gone, so the ProjectFlow context
// (selected project/masterplan/building/...) and the breadcrumb trail are empty.
// The URL carries the ids we need (directly, or via a quick lookup up the chain),
// so we rebuild the *ancestor* context + crumbs here; each Explore view still
// adds its own leaf crumb on mount. We only act when the breadcrumb history is
// empty — during normal in-app navigation it is not, so this is a no-op.

// Each helper ensures the whole chain above the entity is present, then adds the
// entity itself as an ancestor crumb (+ context). They compose recursively, so a
// crumb is always added after its parent, keeping the trail in order.
function hasCrumb(text) {
  return store.state.BreadcrumbsStore.history.some(c => c.text === text)
}
async function addProjectAncestor(projectId) {
  if (!projectId) return
  await store.dispatch('ProjectStore/setSelectedProject', projectId)
  const project = store.state.ProjectStore.selectedProject
  // setSelectedProject doesn't push a crumb (ProjectExplore does that via a
  // watcher, which isn't mounted on deeper routes), so add it here.
  if (project && !hasCrumb('PROJECT ')) {
    await store.dispatch('BreadcrumbsStore/add', {
      text: 'PROJECT ',
      name: project.name
    })
  }
}
async function addMasterplanAncestor(masterplanId) {
  if (!masterplanId) return
  const mp = (await MasterplanService.getMasterplanById(masterplanId)).data
  await addProjectAncestor(mp && (mp.projectsId || mp.projectId))
  // setSelectedMasterplan sets context and pushes the MASTERPLAN/COMMUNITY crumb.
  await store.dispatch('MasterplanStore/setSelectedMasterplan', masterplanId)
}
async function addBuildingAncestor(buildingId) {
  if (!buildingId) return
  const b = (await BuildingService.getBuildingById(buildingId)).data
  await addMasterplanAncestor(b && (b.masterplansId || b.masterplanId))
  await store.dispatch('BuildingStore/setSelectedBuilding', buildingId)
}
async function addApartmentAncestor(apartmentId) {
  if (!apartmentId) return
  const a = (await ApartmentService.getApartmentById(apartmentId)).data
  await addBuildingAncestor(a && (a.buildingId || a.buildingsId))
  await store.dispatch('ApartmentStore/setSelectedApartment', apartmentId)
}

// POI urls carry no ancestor ids; the parent is discovered from the poi's
// parentId + its poi-type's parentType, then we walk up from there.
async function rebuildPoiAncestors(poiId) {
  const poi = (await PoiService.getPoiById(poiId)).data
  if (!poi) return
  const types = (await PoiService.getAllPoiTypes()).data || []
  const type = types.find(t => t.typeId === poi.poiTypeId)
  const parentType = type && type.parentType
  if (parentType === 'masterplan') await addMasterplanAncestor(poi.parentId)
  else if (parentType === 'building') await addBuildingAncestor(poi.parentId)
  else if (parentType === 'apartment') await addApartmentAncestor(poi.parentId)
  else if (parentType === 'project') await addProjectAncestor(poi.parentId)
  // PoiExplore only UPDATEs an existing 'P.O.I ' crumb, so add the leaf here.
  if (!hasCrumb('P.O.I ')) {
    await store.dispatch('BreadcrumbsStore/add', {
      text: 'P.O.I ',
      name: poi.name
    })
  }
}

async function rehydrateProjectFlowContext(to) {
  if (store.state.BreadcrumbsStore.history.length > 0) return
  const p = to.params || {}
  try {
    // Property hierarchy — ids are in the URL, so build ancestors directly and
    // let the leaf view add its own crumb.
    if (p.apartmentId || p.apartmentTypeId || p.apartmentOrientationId) {
      await addMasterplanAncestor(p.masterplanId) // PROJECT + MASTERPLAN
      if (p.buildingId) {
        await store.dispatch('BuildingStore/setSelectedBuilding', p.buildingId)
      }
    } else if (p.buildingId || p.parcelId) {
      // leaf = building / parcel; ancestors = PROJECT + MASTERPLAN
      await addMasterplanAncestor(p.masterplanId)
    } else if (p.masterplanId) {
      // leaf = masterplan; ancestor = PROJECT only
      const mp = (await MasterplanService.getMasterplanById(p.masterplanId))
        .data
      await addProjectAncestor(mp && (mp.projectsId || mp.projectId))
    } else if (p.packagesId) {
      // Packages hang directly off a project.
      const pkg = (await PackageService.getProjectPackagesById(p.packagesId))
        .data
      await addProjectAncestor(pkg && (pkg.projectsId || pkg.projectId))
    } else if (p.poiId) {
      await rebuildPoiAncestors(p.poiId)
    } else if (p.projectId && to.name !== 'Explore Project') {
      // Media-manager / project-media routes: project context only.
      // 'Explore Project' self-heals via its own view, so skip it.
      await addProjectAncestor(parseInt(p.projectId))
    }
  } catch (e) {
    // Best-effort: a failed fetch (e.g. expired token) is handled by the
    // per-route ifAuthenticated guard, which redirects to login.
    console.warn('Context rehydration skipped:', e)
  }
}

router.beforeEach(async (to, from, next) => {
  await rehydrateProjectFlowContext(to)
  next()
})

router.afterEach((to, from, next) => {
  if (store.getters.guardBeforeLeaveEnabled) {
    store.dispatch('disableGuardBeforeLeave')
  }
})

export default router
